import { FleekError } from './FleekError';

export class EnvNotSetError extends FleekError<string> {
  public name = 'EnvNotSetError';

  toString = () => (this.data ? `Environment variable "${this.data}" is not set.` : `Missing the defined object key pair values.`);
}
